import type {
  Location,
  LocationArchiveReasonCode,
  LocationEndedBy,
  LocationLifecycleStatus,
} from '@/types/location';

export const locationArchiveReasonLabels: Record<LocationArchiveReasonCode, string> = {
  store_closed: 'Store closed',
  customer_non_renewal: 'Customer did not renew',
  tpb_non_renewal: 'TPB did not renew',
  switched_provider: 'Switched provider',
  payment_issue: 'Payment issue',
  ownership_change: 'Ownership change',
  location_replaced: 'Location replaced',
  duplicate_record: 'Duplicate record',
  other: 'Other',
};

export const locationEndedByLabels: Record<LocationEndedBy, string> = {
  customer: 'Customer',
  tpb: 'TPB',
  mutual: 'Mutual',
  unknown: 'Unknown',
};

export const locationArchiveReasonOptions = Object.entries(locationArchiveReasonLabels).map(
  ([value, label]) => ({
    value: value as LocationArchiveReasonCode,
    label,
  })
);

export const locationEndedByOptions = Object.entries(locationEndedByLabels).map(([value, label]) => ({
  value: value as LocationEndedBy,
  label,
}));

export function getLocationLifecycleStatus(
  location: Pick<Location, 'lifecycle_status'>
): LocationLifecycleStatus {
  return location.lifecycle_status ?? 'active';
}

export function isLocationArchived(location: Pick<Location, 'lifecycle_status'>): boolean {
  return getLocationLifecycleStatus(location) === 'archived';
}

export function getLocationArchiveReasonLabel(
  reasonCode: LocationArchiveReasonCode | null | undefined
): string {
  return reasonCode ? locationArchiveReasonLabels[reasonCode] ?? 'Archived' : 'Archived';
}

export function getLocationEndedByLabel(endedBy: LocationEndedBy | null | undefined): string | null {
  return endedBy ? locationEndedByLabels[endedBy] ?? null : null;
}
